import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';


const DashboardHeader = ({ totalShipments, activeShipments }) => {
  const navigate = useNavigate();

  const handleCreateShipment = () => {
    navigate('/create-new-shipment');
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0">
        <div>
          <h1 className="text-2xl font-bold text-foreground mb-2">Tableau de bord des envois</h1>
          <p className="text-muted-foreground">Gérez et suivez tous vos envois ADT Express</p>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center space-y-3 sm:space-y-0 sm:space-x-4">
          <div className="flex items-center space-x-6">
            <div className="text-center">
              <div className="text-2xl font-bold text-foreground">{totalShipments}</div>
              <div className="text-xs text-muted-foreground">Total envois</div>
            </div>
            <div className="h-12 w-px bg-border"></div>
            <div className="text-center">
              <div className="text-2xl font-bold text-primary">{activeShipments}</div>
              <div className="text-xs text-muted-foreground">En cours</div>
            </div>
          </div>

          <Button
            variant="default"
            size="lg"
            onClick={handleCreateShipment}
            iconName="Plus"
            iconPosition="left"
          >
            Nouveau envoi
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DashboardHeader;